module.exports = __webpack_public_path__ + "img/1509601938.651bb4ed.jpg";